// import { useParams } from 'react-router-dom';

import {TypesGetEmpreendimentoImovelResponse} from '../../../../../graphql/type'
import {Loader} from '../../../../../components/UI/Loader/Loader'
import {Buttons} from './partials/Actions'
import {CoordinatesToPath, MapView} from '../../../../../components/UI/MapView'
import {DateTimToView, marcadoresMap} from '../../../../../components/util'
import {CreateForm} from './components/CreateForm'
import {useState} from 'react'
import {BiExport, BiPlus, BiSync} from 'react-icons/bi'
import * as turf from '@turf/turf'
import Swal from 'sweetalert2'
import * as XLSX from 'xlsx'
import {useApolloClient} from '@apollo/client'

import {
  MutationSetImovelAddEmpreedimento,
  QueryGetEmpreendimentoImoveis,
} from '../../../../../graphql'
import {MutationSetLogAcessoRecurso} from '../../../../../graphql/services/LogAcesso'
import {formatAdressSeachGoogleMapa} from '../../../../explorer/components/common'
import {Endereco} from '../../../../explorer/components/Map/ComponentsControl/EnderecoControl/endereco'
import {ApiUrbit} from '../../../../../../infra/http/urbit'
import {Geometry} from '@turf/turf'
import {ModalInfo} from './partials/ModalInfo'
import {LoaderButton} from '../../../../../components/UI/Loader/LoaderButton'
import {GET_IMOVEL_PROPRIETARIO} from '../../../../../graphql/query/imovel-proprietarios'
import {TypesGetImovelProprietariosResponse} from '../../../../../graphql/type/imovel-proprietario'
type Props = {
  imoveis: TypesGetEmpreendimentoImovelResponse
  OpenModalMeusImoveis: any
  idEmpreendimento: number
  infoEmp: any
  param: string
}

export const TabComposicaoTerrenos: React.FC<Props> = ({
  imoveis,
  OpenModalMeusImoveis,
  idEmpreendimento,
  infoEmp,
  param,
}) => {
  const [showCreate, setShowCreate] = useState(false)
  const apolloClient = useApolloClient()
  const {FormImovelAddEmpreendimento} = MutationSetImovelAddEmpreedimento()
  const {FormSetLogAcessoRecurso} = MutationSetLogAcessoRecurso()
  const [showLoader, setShowLoader] = useState({
    id: null,
    show: false,
  })
  let latlng = []

  const {data: dataImoveis} = QueryGetEmpreendimentoImoveis({
    variables: {
      idEmpreendimento: idEmpreendimento,
      pagination: {
        pagina: 0,
        quantidade: 50,
      },
    },
  })

  if (!dataImoveis) {
    return <Loader text={'caregando...'}></Loader>
  }

  async function ExportKMZ(uuid) {
    await fetch(
      // process.env.REACT_APP_API_URL_EXTRA_SERVICES + '/export-kmz/8adc0938-681d-11ee-b708-2618765f0467',
      process.env.REACT_APP_API_URL_EXTRA_SERVICES + '/export-kmz/' + uuid,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )
      .then((res) => res.blob())
      .then((blob) => {
        var url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        a.download = infoEmp.nome + '.kmz'
        document.body.appendChild(a) // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click()
        a.remove() //afterwards we remove the element again
      })
      .catch((e) => {
        console.log(e)
      })

    FormSetLogAcessoRecurso({
      action: 'export',
      ferramenta: 'empreendimento',
      funcionalidade: 'composicao-terrenos',
      url: `/empreendimentos/details/${idEmpreendimento}#composicao-terrenos`,
    })
  }
  function parseJsonField(value: any) {
    if (!value) return null

    if (typeof value === 'string') {
      try {
        return JSON.parse(value)
      } catch {
        return null
      }
    }

    return value
  }

  function getBasicDataName(basicData: any) {
    if (!basicData) return null

    const basicResult = Array.isArray(basicData?.Result) ? basicData.Result[0] : null
    const basicInfo = basicResult?.BasicData || basicData?.BasicData || basicData

    return (
      basicInfo?.Name ||
      basicInfo?.OfficialName ||
      basicInfo?.TradeName ||
      basicInfo?.RazaoSocial ||
      null
    )
  }

  function getPh3aName(ph3aData: any) {
    if (!ph3aData) return null

    return ph3aData?.NameBrasil || ph3aData?.Name || ph3aData?.Person?.Name || null
  }

  function extractEmails(ph3aData: any, emailsExtended: any) {
    const emails = []

    if (Array.isArray(ph3aData?.Emails)) {
      ph3aData.Emails.forEach((item) => {
        if (item?.Email) emails.push(item.Email)
      })
    }

    const extendedResult = Array.isArray(emailsExtended?.Result)
      ? emailsExtended.Result[0]
      : Array.isArray(emailsExtended)
      ? emailsExtended[0]
      : null

    const extendedEmails = extendedResult?.ExtendedEmails?.Emails
    if (Array.isArray(extendedEmails)) {
      extendedEmails.forEach((item) => {
        if (item?.EmailAddress) emails.push(item.EmailAddress)
      })
    }

    return [...new Set(emails.filter(Boolean))]
  }

  function extractPhones(ph3aData: any, phonesExtended: any) {
    const phones = []

    if (Array.isArray(ph3aData?.Phones)) {
      ph3aData.Phones.forEach((item) => {
        if (item?.FormattedNumber) {
          phones.push(item.FormattedNumber)
          return
        }

        if (item?.AreaCode && item?.Number) {
          phones.push(`${item.AreaCode}${item.Number}`)
        }
      })
    }

    const extendedResult = Array.isArray(phonesExtended?.Result)
      ? phonesExtended.Result[0]
      : Array.isArray(phonesExtended)
      ? phonesExtended[0]
      : null

    const extendedPhones = extendedResult?.ExtendedPhones?.Phones
    if (Array.isArray(extendedPhones)) {
      extendedPhones.forEach((item) => {
        if (item?.AreaCode && item?.Number) {
          phones.push(`${item.AreaCode}${item.Number}`)
        } else if (item?.FormattedNumber) {
          phones.push(item.FormattedNumber)
        }
      })
    }

    return [...new Set(phones.filter(Boolean))]
  }

  async function ExportXls() {
    const dataToExport = []
    const proprietariosToExport = []
    let somaarea = 0
    // let somaareareal = 0
    let somatestada = 0
    let totalAreaCalculada = 0
    let totalAreaConstruida = 0

    // eslint-disable-next-line array-callback-return
    dataImoveis.GetEmpreendimentoImovel.result.map((item) => {
      if (!item.terreno) return null
      somaarea += item.terreno?.area_iptu || 0
      // somaareareal += item.terreno.area_real || 0
      somatestada += item.terreno.testada || 0

      let area_calculada = item.terreno?.marcacao ? turf.area(item.terreno.marcacao as Geometry) : 0

      totalAreaCalculada += area_calculada
      totalAreaConstruida += item?.terreno.area_construida
        ? Number(item.terreno.area_construida)
        : 0
      console.log('item')
      console.log(item)
      // console.log(item)
      dataToExport.push({
        'Id Empreendimento': item.id_empreendimento,
        id: item.terreno.id,
        Endereço: item.terreno.endereco,
        Número: item.terreno.numero,
        // 'Bairro':item.terreno.bairro,
        Cidade: item.terreno.cidade,
        Latitude: item.terreno.latitude,
        Longitude: item.terreno.longitude,
        Zoneamento: item.terreno.zoneamento,
        'Área Iptu': Number(item.terreno.area_iptu.toFixed(0)),
        'Área Calculada': Number(area_calculada.toFixed(1)),
        'Área Construída': Number(item.terreno.area_construida),
        // "Situação":item.terreno.si
        'Data Cadastro': item.terreno.data_cadastro,
        Codlog: item.terreno.codlog,
        'Número Contribuinte': item.terreno.numero_contribuinte,
        'Nome Contribuinte': item.terreno.nome_contribuinte,
        'Testada Para Cálculo': item.terreno.testada,
      })
    })

    dataToExport.push({
      'Id Empreendimento':null,
      id:null,
      Endereço: null,
      Número: null,
      Cidade: null,
      Latitude: null,
      Longitude: null,
      Zoneamento: 'Total',
      'Área Iptu': Number(somaarea.toFixed(2)),
      'Área Calculada': Number(totalAreaCalculada.toFixed(1)),
      'Área Construída': Number(totalAreaConstruida.toFixed(1)),
      'Data Cadastro': null,
      Codlog: null,
      'Número Contribuinte': null,
      'Nome Contribuinte': null,
      'Testada Para Cálculo': somatestada,
    })

    await Promise.all(
      dataImoveis.GetEmpreendimentoImovel.result.map(async (item) => {
        if (!item?.terreno?.id) return

        const {data} = await apolloClient.query<TypesGetImovelProprietariosResponse>({
          query: GET_IMOVEL_PROPRIETARIO,
          variables: {idImovel: item.terreno.id},
          fetchPolicy: 'no-cache',
        })

        if (!data?.GetImovelProprietarios?.length) return

        data.GetImovelProprietarios.forEach((proprietario) => {
          const basicData = parseJsonField(proprietario.basic_data)
          const ph3aData = parseJsonField(proprietario.ph3a_data)
          const phonesExtended = parseJsonField(proprietario.phones_extended)
          const emailsExtended = parseJsonField(proprietario.emails_extended)

          const nome = proprietario.nome ||
            proprietario.empresa ||
            getPh3aName(ph3aData) ||
            getBasicDataName(basicData) ||
            '-'

          const emails = extractEmails(ph3aData, emailsExtended)
          const phones = extractPhones(ph3aData, phonesExtended)

          proprietariosToExport.push({
            Imovel: `${item.terreno.endereco || ''}, ${item.terreno.numero || ''}`.trim(),
            'Número Contribuinte': item.terreno.numero_contribuinte || '',
            Nome: nome,
            Emails: emails.join(' | '),
            Telefones: phones.join(' | '),
            'Grau Parentesco': proprietario.grau_parentesco || '',
          })
        })
      })
    )

    const worksheet = XLSX.utils.json_to_sheet(dataToExport)
    const proprietariosWorksheet = XLSX.utils.json_to_sheet(
      proprietariosToExport.length > 0
        ? proprietariosToExport
        : [{Nome: '', Emails: '', Telefones: ''}]
    )
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, worksheet, 'imoveis')
    XLSX.utils.book_append_sheet(wb, proprietariosWorksheet, 'proprietarios')
    XLSX.writeFile(wb, infoEmp.id + '-' + infoEmp.nome + '.xlsx')

    FormSetLogAcessoRecurso({
      action: 'export',
      ferramenta: 'empreendimento',
      funcionalidade: 'composicao-terrenos',
      url: `/empreendimentos/details/${idEmpreendimento}#composicao-terrenos`,
    })
  }
  function OpenModalCreate(id) {
    setShowCreate(true)
  }

  function CloseModalCreate() {
    setShowCreate(false)
  }

  async function getGeocoder(lat: number, lng: number) {
    const geocoder = new google.maps.Geocoder()
    const latLng = new google.maps.LatLng(lat, lng)
    return geocoder.geocode({location: latLng}, async function (results, status) {
      if (status === 'OK') {
        var place = results[0]
        var adr_elements = formatAdressSeachGoogleMapa(place)
        return adr_elements
      }
    })
  }
  async function onClickMap(lat, lng, cidade = 'sao-paulo') {
    // console.log(dataImoveis)
    // if (dataImoveis.GetEmpreendimentoImovel.result.length > 0) {
    const result = await ApiUrbit.getServico('lote-fiscal', lat, lng, cidade, 0)

    if (result) {
      Swal.close()
      if (result) {
        if (result.itens.length > 0) {
          const lote = result.itens[0]
          result.itens[0].lat = lat
          result.itens[0].lng = lng
          let loteJson = ''
          if (lote.geom) {
            loteJson = JSON.parse(lote.geom)
          }
          let dados = result.itens[0]
          if (!dados.logradouro) {
            let result = await getGeocoder(lat, lng)
            let municipio = await Endereco.getMunicipioAPI(lat, lng)
            var adr_elements = formatAdressSeachGoogleMapa(result.results[0])

            dados['logradouro'] = adr_elements['logradouro']
            dados['bairro'] = adr_elements['bairro']
            dados['numero'] = adr_elements['numero']
            dados['cep'] = adr_elements['cep']
            dados['cidade'] = municipio['nome']
            dados['id_cidade'] = municipio['id']
            dados['id_estado'] = municipio['estado_id']
          }
          Swal.fire({
            title: 'Adicionar este lote ao meu empreendimento?',
            confirmButtonText: 'Adicionar',
            showConfirmButton: true,
            cancelButtonText: 'Cancelar',
            showCancelButton: true,
          }).then((resultQuestion) => {
            if (resultQuestion.value === true) {
              const data = {
                idEmpreendimento: idEmpreendimento,
                nome: dados.logradouro + ',' + dados.numero,
                endereco: dados.logradouro,
                numero: String(dados.numero),
                complemento: dados.complemento,
                cep: dados.cep,
                area_iptu: Number(dados.area_lote),
                area_real: Number(dados.area_lote),
                numero_contribuinte: dados.numero_contribuinte,
                id_situacao: 1,
                latitude: String(lat),
                longitude: String(lng),
                setor_quadra: dados.setor + '' + dados.quadra,
                // setor:dados.setor,
                // quadra: dados.quadra,
                uso_atual_terreno: dados.uso_atual,
                codlog: dados.codlog,
                terreno_esquina: String(dados.quantidade_de_esquinas_frentes),
                postgis_municipio_id: Number(dados.id_cidade),
                terrain_type: 'IMOVEL',
                testada: Number(dados.testada),
                metragem: Number(dados.area_lote),
                cod_condomio: dados.lote === '0000' ? '00' : null,
                id_estado: Number(dados.id_estado),
                id_cidade: Number(dados.id_cidade),
                nome_contribuinte: dados.nome_contribuinte,
                numero_lote: String(dados.id),
                marcacao: JSON.stringify(loteJson),
              }
              FormImovelAddEmpreendimento(data)
            }
          })
        }
      }
      // }
    } else {
      Swal.close()
    }
  }

  async function syncInfos(id) {
    const response = await fetch(
      process.env.REACT_APP_API_URL_EXTRA_SERVICES + 'sync-imovel/' + id,
      // 'http://localhost:4001/sync-imovel/' + id,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      }
    )

    const data = await response.json()
    console.log(data)
    setShowLoader({
      id: null,
      show: false,
    })

    FormSetLogAcessoRecurso({
      ferramenta: 'meus-imoveis',
      funcionalidade: 'informacoes-lote',
      action: 'list',
      url: '/empreendimentos/details/' + id + '#composicao-terrenos',
    })
    window.location.reload()
  }

  let label = dataImoveis
    ? dataImoveis.GetEmpreendimentoImovel.result.map((imovel) => {
        if (imovel.terreno?.numero_contribuinte) {
          return imovel.terreno?.numero_contribuinte?.substring(7, 10)
        } else {
          return null
        }
      })
    : []

  label = label.filter((item) => item)
  // `${ Response.terreno?.numero_contribuinte ? Response.terreno.numero_contribuinte.substring(6, 10) : '' }`
  let totalArea = 0
  let totalTestada = 0
  let totalAreaCalculada = 0
  let count = -1
  return (
    <div
      className={`tab-pane fade ${param === 'composicao-terrenos' ? ' show active' : ''}`}
      id='composicao-terrenos'
      role='tabpanel'
      aria-labelledby='composicao-terrenos'
    >
      <div className='card'>
        <div className='card-header'>
          <h3 className='card-title'>Composição de Terrenos</h3>
          <div className='card-toolbar flex-fill'>
            <div className='flex-fill'>
              {/* <TemperatureBar
                className='justify-content-center'
                SetValueSituacao={(value) => {
                  // setValue('id_temperatura', value)
                }}
                valueSituacao={infoEmp.empreendimento_temperatura?.nome}
                showLabel={false}
                disabled={true}
              /> */}
            </div>
            <button
              className='btn btn-sm btn-light-primary me-3'
              onClick={(e) => {
                e.preventDefault()
                ExportKMZ(infoEmp.uuid)
              }}
            >
              <BiExport className='fs-3'></BiExport>
              Exportar KMZ
            </button>
            <button
              className='btn btn-sm btn-light-primary me-3'
              onClick={(e) => {
                e.preventDefault()
                ExportXls()
              }}
            >
              <BiExport className='fs-3'></BiExport>
              Exportar XLS
            </button>

            <button
              className='btn btn-sm btn-light-primary'
              onClick={(e) => {
                e.preventDefault()
                OpenModalCreate(null)
              }}
            >
              <BiPlus className='fs-3'></BiPlus>
              Adicionar Terreno
            </button>
            <CreateForm
              idEmpreendimento={idEmpreendimento}
              closeModal={CloseModalCreate}
              show={showCreate}
            />
          </div>
        </div>
        <div className='table-responsive'>
          {/* begin::Table */}
          <table className='table  table-row-dashed  gy-2 gs-6 table-row-bordered  table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            {/* begin::Table head */}
            <thead>
              <tr className='fw-bolder text-muted' key={0}>
                <th className='min-w-20px'>x</th>
                <th className='min-w-100px text-center'>Cód Lote</th>
                <th className='min-w-20px'>Situação</th>
                <th className='min-w-150px'>Terreno</th>
                <th className='min-w-100px text-center'>Codlog</th>
                <th className='min-w-100px text-center'>Área IPTU</th>
                <th className='min-w-100px text-center'>Área Calculada</th>
                <th className='min-w-100px text-center'>Testada</th>
                <th className='min-w-100px text-center'>Zona</th>
                <th className='min-w-150px'>Nº Contribuinte</th>
                <th className='min-w-100px '>Data Cadastro</th>
                <th className='min-w-100px text-center'>Ações</th>
              </tr>
            </thead>

            {/* end::Table head */}
            {/* begin::Table body */}
            <tbody>
              {dataImoveis ? (
                dataImoveis.GetEmpreendimentoImovel.result.length > 0 ? (
                  // eslint-disable-next-line array-callback-return
                  dataImoveis.GetEmpreendimentoImovel.result.map((Response, item) => {
                    totalArea += Response.terreno ? Response.terreno.area_iptu : 0
                    totalTestada += Response.terreno ? Response.terreno.testada : 0
                    if (Response.terreno) {
                      if (Response.terreno.marcacao) {
                        let path = null
                        if (Response.terreno.marcacao.type === 'MultiPolygon') {
                          path = CoordinatesToPath(Response.terreno.marcacao['coordinates'][0][0])
                        } else if (Response.terreno.marcacao.type === 'Polygon') {
                          path = CoordinatesToPath(Response.terreno.marcacao['coordinates'][0])
                        }

                        latlng.push({
                          path: path,
                          center: turf.centroid(Response.terreno.marcacao),
                          id: Response.terreno.id,
                          endereco: Response.terreno.endereco,
                          area: Response.terreno.area_iptu,
                          id_cidade: Response.terreno.id_cidade,
                          editable: false,
                          color: Response.terreno.terreno_situacao_cliente?.cor,
                        })
                      }

                      let area_calculada = Response.terreno?.marcacao
                        ? turf.area(Response.terreno.marcacao as Geometry)
                        : 0

                      totalAreaCalculada = totalAreaCalculada + area_calculada
                      count++
                      return (
                        <tr key={item} id={'row_' + Response.terreno.id} className='row-composicao'>
                          <td>{marcadoresMap[count]}</td>
                          <td className='d-flex align-items-center dlex-row justify-content-center '>
                            <div className='d-flex align-items-center dlex-row justify-content-center '>
                              <ModalInfo terreno={Response.terreno}></ModalInfo>

                              <div className='text-dark d-flex flex-column align-items-center justify-content-center '>
                                {Response.terreno?.numero_contribuinte
                                  ? Response.terreno.numero_contribuinte.substring(6, 10)
                                  : ''}

                                {Response.terreno.id_cidade === 5351 &&
                                Response.terreno.sincronizado === 'pendente' ? (
                                  <i className='badge badge-info d-flex align-items-center  justify-content-center'>
                                    Pendente{' '}
                                    <>
                                      <div
                                        className='cursor-pointer'
                                        onClick={() => {
                                          window.location.reload()
                                        }}
                                      >
                                        <BiSync className='fs-4'></BiSync>
                                      </div>
                                    </>
                                  </i>
                                ) : Response.terreno.id_cidade === 5351 &&
                                  Response.terreno.sincronizado === 'erro' ? (
                                  <>
                                    <i className='badge badge-danger d-flex align-items-center justify-content-center'>
                                      Erro ao sincronizar{' '}
                                      <div
                                        className='cursor-pointer'
                                        onClick={() => {
                                          setShowLoader({
                                            id: Response.terreno.id,
                                            show: true,
                                          })
                                          syncInfos(Response.terreno.id)
                                        }}
                                      >
                                        <BiSync className='fs-4'></BiSync>
                                      </div>
                                    </i>
                                  </>
                                ) : Response.terreno.id_cidade === 5351 &&
                                  !Response.terreno.sincronizado ? (
                                  <i className='badge badge-warning d-flex align-items-center justify-content-center'>
                                    sincronizar{' '}
                                    <div
                                      className='cursor-pointer'
                                      onClick={() => {
                                        setShowLoader({
                                          id: Response.terreno.id,
                                          show: true,
                                        })
                                        syncInfos(Response.terreno.id)
                                      }}
                                    >
                                      <BiSync className='fs-4'></BiSync>
                                    </div>
                                  </i>
                                ) : (
                                  <></>
                                )}

                                {showLoader.id === Response.terreno.id && showLoader.show ? (
                                  <div className=' d-flex align-items-center justify-content-center'>
                                    <LoaderButton text={'Sincronizando...'}></LoaderButton>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className='d-flex justify-content-center align-items-center gap-1 '>
                              <span
                                className='badge  fw-bold me-auto px-1 py-2'
                                style={{
                                  backgroundColor: Response.terreno.terreno_situacao_cliente?.cor,
                                  color: Response.terreno.terreno_situacao_cliente?.cor,
                                }}
                              >
                                .
                              </span>{' '}
                              <span className='flex-fill'>
                                {' '}
                                {Response.terreno.terreno_situacao_cliente?.nome}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div className='d-flex align-items-center'>
                              <div className='d-flex justify-content-start flex-column'>
                                <p className='text-dark text-hover-primary fs-6'>
                                  {Response.terreno.endereco}, {Response.terreno.numero}
                                </p>
                                {Response.terreno.users?.name}
                              </div>
                            </div>
                          </td>
                          <td>
                            <div className='text-center'>
                              <p className='text-dark text-hover-primary fs-6 text-center'>
                                {Response.terreno.codlog}
                              </p>
                            </div>
                          </td>
                          <td>
                            <div className='text-center'>
                              <p className='text-dark text-hover-primary fs-6 text-center'>
                                {Response.terreno.area_iptu}m²
                              </p>
                            </div>
                          </td>
                          <td>
                            <div className='text-center'>
                              <p className='text-dark text-hover-primary fs-6 text-center'>
                                {area_calculada.toFixed(0)}m²
                              </p>
                            </div>
                          </td>
                          <td>
                            <div className=' text-center'>
                              <p className='text-dark text-hover-primary fs-6 text-center'>
                                {Response.terreno.testada}
                              </p>
                            </div>
                          </td>

                          <td className='text-center'>
                            {/* <div className='d-flex align-items-center'> */}
                            {/* <div className='d-flex justify-content-start flex-column'>
                                <p className='text-dark text-hover-primary fs-6 text-center'> */}
                            {Response.terreno.zoneamento || '-'}
                            {/* </p> */}
                            {/* </div>
                            </div> */}
                          </td>
                          <td>
                            <div className='d-flex align-items-center'>
                              <div className='d-flex justify-content-start flex-column'>
                                <p className='text-dark text-hover-primary fs-6'>
                                  {Response.terreno.numero_contribuinte}
                                </p>
                              </div>
                            </div>
                          </td>

                          <td>
                            <p className='text-dark text-hover-primary d-block fs-6'>
                              {DateTimToView(Response.terreno.data_cadastro)}
                            </p>
                          </td>
                          {!infoEmp.bloqueado ? (
                            <td>
                              <Buttons
                                id={Response.terreno.id}
                                idEmpreendimentoImovel={Response.id}
                                response={Response}
                                OpenModalMeusImoveis={OpenModalMeusImoveis}
                              />
                            </td>
                          ) : (
                            <td>-</td>
                          )}
                        </tr>
                      )
                    }
                  })
                ) : (
                  <tr key={1}>
                    <td colSpan={9} className='text-center'>
                      Nenhum terreo cadastrado
                    </td>
                  </tr>
                )
              ) : (
                ''
              )}
            </tbody>
            <tfoot>
              <tr style={{backgroundColor: '#d0d0d0', fontWeight: '600'}}>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>Área Total</td>
                <td className='text-center'>{totalArea}m² </td>
                <td className='text-center'>{totalAreaCalculada.toFixed(0)}m²</td>
                <td className='text-center'>{totalTestada.toFixed(2)} </td>

                <td></td>

                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div className='card-body p-6 pt-5'>
          <div className='col-md-12'>
            <div className='row '>
              {latlng ? (
                <MapView
                  idEmpreendimento={idEmpreendimento}
                  latLng={latlng}
                  onClickMap={onClickMap}
                  key={1}
                  label={label}
                ></MapView>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
